import { Orientation, Variant } from '../types'

export const getCardWidth = ({
  dimensions,
  orientation,
}: {
  dimensions: string
  orientation: Orientation
}) => {
  const sizeIndex = orientation === Orientation.Landscape ? 1 : 0
  return parseFloat(dimensions.split(' ').sort()[sizeIndex])
}

export const getCardScaleValue = ({
  cardWidth,
  orientation,
}: {
  cardWidth: number
  orientation: Orientation
}) => {
  const a4Value = orientation === Orientation.Landscape ? 297 : 210

  return parseFloat((cardWidth / a4Value).toFixed(2))
}

export const getCardSizeTransformDetails = ({
  variant,
  orientation,
}: {
  variant: Variant
  orientation: Orientation
}) => {
  const scales = [
    {
      x: '0',
      y: '0',
      orientation: Orientation.Portrait,
    },
    {
      x: '5%',
      y: '-15%',
      orientation: Orientation.Landscape,
    },
    {
      x: '0',
      y: '0%',
      orientation: Orientation.Square,
    },
  ]

  const addScaleToDimensions = scales
    .filter(item => {
      return item.orientation === orientation
    })
    .map(item => {
      const cardWidth = getCardWidth({
        dimensions: variant.dimensions,
        orientation,
      })
      const cardScale = getCardScaleValue({ cardWidth, orientation })
      return {
        ...item,
        scale: cardScale,
      }
    })

  return addScaleToDimensions
}

export const getCurrentCardScaleValue = ({
  orientation,
  variant,
}: {
  orientation: Orientation
  variant: Variant
}) => {
  const transformDetails = getCardSizeTransformDetails({
    variant,
    orientation,
  })

  return (
    transformDetails[0] || {
      scale: 1,
      x: 0,
      y: 0,
    }
  )
}
